import { CommonErrors, CommonRecord } from "../../../../common/CommonTypes";

export class StromNetzRecord extends CommonRecord {
  [key: string]: any;   // prevents typescript error ts7053: Element implicitly has an 'any' type

  Spannungsebene: string = "";
  Leistungsbedarf: string = "";
  LageBeschreibung: string = "";           // Beschreibung

  Leistungsaenderung: string = "";
  Leistung: string = "";

  AbzumeldendeLeistung: string = "";
}


export class StromNetzErrors extends CommonErrors{
  [key: string]: any;  // prevents typescript error ts7053: Element implicitly has an 'any' type

  Spannungsebene: string = "";
  Leistungsbedarf: string = ""; 
  LageBeschreibung: string = "";           // Beschreibung

  Leistungsaenderung: string = "";
  Leistung: string = "";

  AbzumeldendeLeistung: string = "";
}
  